import React from 'react';
import { formatNumber } from '@util/formatNum';
import { NumberFormatType } from '../../util/enums';
function toPercentage(value) {
    return "".concat(value * 100, "%");
}
function getIndicatorPosition(min, max) {
    var start;
    if (min >= 0) {
        //If min is less than/equal zero start at 0%
        start = 0;
    }
    else if (max <= 0) {
        //If max is less than/equal zero start at 100%
        start = 1;
    }
    else {
        //Else calculate ratio
        var minAbs = Math.abs(min);
        start = minAbs / (minAbs + +max);
    }
    return start;
}
function getFillStyle(value, min, max, ratio) {
    var fillRatio;
    var startRatio;
    if (ratio === 1) {
        startRatio = Math.abs((value - min) / (max - min));
        fillRatio = ratio;
    }
    else if (ratio === 0) {
        fillRatio = (value - min) / (max - min);
        startRatio = ratio;
    }
    else {
        if (value > 0) {
            fillRatio = (Math.abs(min) + value) / (Math.abs(min) + max) - ratio;
            startRatio = ratio;
        }
        else {
            startRatio = Math.abs(min - value) / (Math.abs(min) + max);
            fillRatio = 1 - (startRatio + 1 - ratio);
        }
    }
    return { left: toPercentage(startRatio), width: toPercentage(fillRatio) };
}
function RangeIndicator(props) {
    var _a = props.min, min = _a === void 0 ? 0 : _a, _b = props.max, max = _b === void 0 ? 100 : _b, value = props.value, percentage = props.percentage;
    var startRatio = getIndicatorPosition(min, max);
    var fillStyle = getFillStyle(value, min, max, startRatio);
    var percentSign = percentage ? '%' : '';
    return (React.createElement("div", { className: "range-container" },
        React.createElement("div", { className: "range-track" },
            React.createElement("div", { className: "range-indicator", style: fillStyle })),
        React.createElement("div", { className: "range-footer" },
            React.createElement("p", { className: "range-value" }, (percentage ? formatNumber(min, NumberFormatType.WHOLE_NUMBERS) : min) + percentSign),
            React.createElement("p", { className: "range-value" }, (percentage ? formatNumber(value, NumberFormatType.WHOLE_NUMBERS) : value) + percentSign),
            React.createElement("p", { className: "range-value" }, (percentage ? formatNumber(max, NumberFormatType.WHOLE_NUMBERS) : max) + percentSign))));
}
export default RangeIndicator;
